import { render, staticRenderFns } from "./ArticlesDatatable.vue?vue&type=template&id=5b28e282&"
import script from "./ArticlesDatatable.vue?vue&type=script&lang=ts&"
export * from "./ArticlesDatatable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports